import { render } from "./bothBordeds.vue?vue&type=template&id=4f710c7f"
import script from "./bothBordeds.vue?vue&type=script&lang=js"
export * from "./bothBordeds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__